import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./securityReviewFalsePositives.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { MAX_ASSET_UPLOAD_SIZE, SUPORTED_SRW_FILES_FORMATS } from '~/config';
import { WireI18n, i18nStore } from '~/modules/stores/i18nStore';
import { securityReviewStore, selectFalsePositiveInFailedSR, selectSolution } from '~/modules/stores/securityReviewStore';
import { isApiSolutionType } from '~/modules/utilities/schemaUtilities';
class SecurityReviewFalsePositives extends LightningElement {
  constructor(...args) {
    super(...args);
    this.opsStatus = '';
    this.labels = {};
    this.notificationLabels = {};
    this.sharedLabels = {};
    this.solution = void 0;
    this.enableFalsePositiveDoc = false;
    this.maxAssetUploadSize = MAX_ASSET_UPLOAD_SIZE;
    this.falsePositiveDoc = void 0;
    this.isLoadingReport = false;
    this.securityReviewId = void 0;
    this.onChangeFile = (mediaId, fileName) => {
      if (mediaId && fileName) {
        this.falsePositiveDoc.fileName = fileName;
        this.falsePositiveDoc.mediaId = mediaId;
        securityReviewStore.addFalsePositivesFailedSR(this.falsePositiveDoc);
      } else {
        securityReviewStore.removeFalsePositivesFailedSR();
      }
    };
  }
  i18nCallback(i18n) {
    this.labels = i18n.securityReviewSubmissionFailed;
    this.sharedLabels = i18n.shared;
    this.notificationLabels = i18n.notifications;
  }
  securityReviewStoreConnected(state) {
    this.solution = selectSolution(state);
    this.opsStatus = state.securityReviewOps.status;
    this.falsePositiveDoc = selectFalsePositiveInFailedSR(state);
    this.securityReviewId = state.securityReview.id;
  }
  get showFalsePositivesUpload() {
    return this.enableFalsePositiveDoc || this.falsePositiveDoc && Boolean(this.falsePositiveDoc.fileName);
  }
  get supportedFormats() {
    return SUPORTED_SRW_FILES_FORMATS;
  }
  get successUploadFileMessage() {
    return i18nStore.getState().i18n.fileUploader.successImageUploadMessage;
  }
  get failedUploadFileMessage() {
    return i18nStore.getState().i18n.fileUploader.failedImageUploadMessage;
  }
  get tooLargeUploadFileMessage() {
    return i18nStore.getState().i18n.fileUploader.tooLargeImageMessage;
  }
  get solutionName() {
    return this.solution ? this.processSolutionName(this.solution) : '';
  }
  processSolutionName(solution) {
    if (!isApiSolutionType(solution.technology)) {
      return solution.solution.name;
    }
    return solution.name;
  }
  uploadStarted() {
    securityReviewStore.incrementUploadingAssets();
  }
  uploadFailed() {
    securityReviewStore.decrementUploadingAssets();
  }
  onChangeHasFalsePositiveDocs() {
    this.enableFalsePositiveDoc = !this.enableFalsePositiveDoc;

    //If the value changes to false, remove the uploaded document
    if (!this.enableFalsePositiveDoc) {
      securityReviewStore.removeFalsePositivesFailedSR();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SecurityReviewFalsePositives, {
  track: {
    falsePositiveDoc: 1
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    securityReviewStoreConnected: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: securityReviewStore
        };
      }
    }
  },
  fields: ["opsStatus", "labels", "notificationLabels", "sharedLabels", "solution", "enableFalsePositiveDoc", "maxAssetUploadSize", "isLoadingReport", "securityReviewId", "onChangeFile"]
});
const __lwc_component_class_internal = _registerComponent(SecurityReviewFalsePositives, {
  tmpl: _tmpl,
  sel: "appx-security-review-false-positives",
  apiVersion: 62
});
export default __lwc_component_class_internal;